import React, { Component } from "react";
import PropTypes from "prop-types";

class PageIndicator extends Component {
  render() {
    // Don't render if there's only one page
    if (this.props.pageCount === 1) {
      return;
    }

    const current = parseInt(this.props.currentPage);
    const enableLinks = this.props.enableLinks;

    const indicators = [];
    for (let page = 0; page < this.props.pageCount; page++) {
      if (page !== current - 1) {
        indicators.push(
          <li key={page}>
            <button
              type="button"
              disabled={!enableLinks}
              onClick={() => this.props.handleClick(page + 1)}
            />
          </li>
        );
      } else {
        indicators.push(
          <li key={page}>
            <div className="current">{page + 1}</div>
          </li>
        );
      }
    }

    return <ul className="apl-page-indicator">{indicators}</ul>;
  }
}

PageIndicator.propTypes = {
  pageCount: PropTypes.number,
  currentPage: PropTypes.number,
  enableLinks: PropTypes.bool,
  handleClick: PropTypes.func,
};

export default PageIndicator;



// WEBPACK FOOTER //
// ./components/common/page-indicator/pageIndicator.jsx